import React from 'react';
import 'office-ui-fabric-react/dist/css/fabric.css';
import './Element.sass';
import { ThemeContext } from '@fluentui/react-theme-provider';
import * as Component from '../Elements/ElementStyles';
import { DefaultButton, Spinner, SpinnerSize } from '@fluentui/react';
import ElementsAirIcon from "../../images/air.svg";
import ElementsEarthIcon from "../../images/earth.svg";
import ElementsFireIcon from "../../images/fire.svg";
import ElementsWaterIcon from "../../images/water.svg";
import ElementsIAIcon from "../../images/ia.svg";
import { useHistory } from "react-router";
import { currencyFormatter, decimalFormatter } from '@/utils/numberFormatter';
import { Donation } from '@/services/DonationService';

type Props =
{
    fire: number,
    earth: number,
    air: number,
    water: number,
    ia: number,
    isLoading: boolean,
    donation?: Donation
}

const ElementCardItem: React.FC<Props> = (props: Props) =>
{
    const theme = React.useContext(ThemeContext);
    const history = useHistory();
    const buttonIAClickEvent = () =>
    {
        history.push("/ElementsIA");
    }

    return(
        <React.Fragment>
            <Component.ElementsContainer>
                <Component.ElementsCardsContainer>
                    <Component.ElementCardWrapper>
                        <Component.ContainerCard theme={theme}>
                            <Component.TitleCard>
                                <Component.TitleText theme={theme}>Fuego</Component.TitleText>
                            </Component.TitleCard>
                            <Component.DataCardContract>
                                <Component.IconContainer>
                                    <img alt="Fire" src={ElementsFireIcon} />
                                </Component.IconContainer>
                                <Component.DataTextContract>
                                    {props.isLoading &&
                                    (
                                        <Spinner size={SpinnerSize.xSmall} />
                                    )}
                                    {!props.isLoading &&
                                    (
                                        <React.Fragment>
                                            {decimalFormatter.format(props.fire)}
                                        </React.Fragment>
                                    )}
                                </Component.DataTextContract>
                            </Component.DataCardContract>
                        </Component.ContainerCard>
                    </Component.ElementCardWrapper>
                    <Component.ElementCardWrapper>
                        <Component.ContainerCard theme={theme}>
                            <Component.TitleCard>
                                <Component.TitleText theme={theme}>Tierra</Component.TitleText>
                            </Component.TitleCard>
                            <Component.DataCardContract>
                                <Component.IconContainer>
                                    <img alt="Earth" src={ElementsEarthIcon} />
                                </Component.IconContainer>
                                <Component.DataTextContract>
                                    {props.isLoading &&
                                    (
                                        <Spinner size={SpinnerSize.xSmall} />
                                    )}
                                    {!props.isLoading &&
                                    (
                                        <React.Fragment>
                                            {decimalFormatter.format(props.earth)}
                                        </React.Fragment>
                                    )}
                                </Component.DataTextContract>
                                <Component.FixedPriceText theme={theme}>(precio fijo: 0,006€)</Component.FixedPriceText>
                            </Component.DataCardContract>
                        </Component.ContainerCard>
                    </Component.ElementCardWrapper>
                    <Component.ElementCardWrapper>
                        <Component.ContainerCard theme={theme}>
                            <Component.TitleCard>
                                <Component.TitleText theme={theme}>Aire</Component.TitleText>
                            </Component.TitleCard>
                            <Component.DataCardContract>
                                <Component.IconContainer>
                                    <img alt="Air" src={ElementsAirIcon} />
                                </Component.IconContainer>
                                <Component.DataTextContract>
                                    {props.isLoading &&
                                    (
                                        <Spinner size={SpinnerSize.xSmall} />
                                    )}
                                    {!props.isLoading &&
                                    (
                                        <React.Fragment>
                                            {decimalFormatter.format(props.air)}
                                        </React.Fragment>
                                    )}
                                </Component.DataTextContract>
                            </Component.DataCardContract>
                        </Component.ContainerCard>
                    </Component.ElementCardWrapper>
                    <Component.ElementCardWrapper>
                        <Component.ContainerCard theme={theme}>
                            <Component.TitleCard>
                                <Component.TitleText theme={theme}>Agua</Component.TitleText>
                            </Component.TitleCard>
                            <Component.DataCardContract>
                                <Component.IconContainer>
                                    <img alt="Water" src={ElementsWaterIcon} />
                                </Component.IconContainer>
                                <Component.DataTextContract>
                                    {props.isLoading &&
                                    (
                                        <Spinner size={SpinnerSize.xSmall} />
                                    )}
                                    {!props.isLoading &&
                                    (
                                        <React.Fragment>
                                            {decimalFormatter.format(props.water)}
                                        </React.Fragment>
                                    )}
                                </Component.DataTextContract>
                            </Component.DataCardContract>
                        </Component.ContainerCard>
                    </Component.ElementCardWrapper>
                </Component.ElementsCardsContainer>
                <Component.IACardWrapper>
                    <Component.ContainerCard theme={theme}>
                        <Component.TitleCard>
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <Component.TitleText theme={theme}>
                                    Elements IA
                                </Component.TitleText>
                                <Component.LogoIA alt="IA" src={ElementsIAIcon} width={"25px"} />
                            </div>
                        </Component.TitleCard>
                        <Component.DataCardContract>
                            <Component.ButtonContainer>
                                <Component.ButtonBuyElements onClick={buttonIAClickEvent}>
                                    Compra
                                </Component.ButtonBuyElements>
                            </Component.ButtonContainer>
                            <Component.DataTextContractIA>
                                {props.isLoading &&
                                (
                                    <Spinner size={SpinnerSize.xSmall} />
                                )}
                                {!props.isLoading &&
                                (
                                    <React.Fragment>
                                        {decimalFormatter.format(props.ia)}
                                    </React.Fragment>
                                )}
                            </Component.DataTextContractIA>
                        </Component.DataCardContract>
                    </Component.ContainerCard>
                </Component.IACardWrapper>
            </Component.ElementsContainer>
            {props.donation !== undefined &&
            (
                <div style={{padding: '0 0 0 10px', marginTop: '10px', width: '100%'}}>
                    <div style={{boxShadow: '0px 0px 16px rgba(8,84,117,0.08)', padding: '12px 10px 8px', marginTop: '8px', borderRadius: '10px'}}>
                        Transforma tus Elements en {props.donation.name}
                        <div style={{display: 'grid', gridTemplateColumns: '2fr 1fr', marginTop: '12px'}}>
                            <span style={{lineHeight: '26px', fontWeight: '600', fontSize: '19px'}}>Recaudado: {currencyFormatter.format(props.donation.amount)}</span>
                            <DefaultButton className="mini-primary-button" style={{verticalAlign: 'middle'}} onClick={() => history.push("/elements/donations")}>
                                Donar
                            </DefaultButton>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    )
}

export default ElementCardItem;